import React from 'react';
import Navbar from '../Navbar/Navbar';
import Photos from '../Photos/Photos';

const Home = () => {

  return (
    <div >
      <Navbar  />
     <Photos />
    </div>
  )
}

export default Home